import { createRouter, createWebHistory } from "vue-router";


//Routes
import routes from "./routes/index.routes"

//Middlewares
import { authMiddleware,permissionsMiddleware } from "./middlewares/index.middleware";




const router = createRouter({
    history: createWebHistory(process.env.BASE_URL),
    routes
})

// routeMiddleware
router.beforeEach(authMiddleware)
router.beforeEach(permissionsMiddleware)




export default router